String.prototype.fixNumbers = function() {
  const persianNumbers = [
      /۰/g,
      /۱/g,
      /۲/g,
      /۳/g,
      /۴/g,
      /۵/g,
      /۶/g,
      /۷/g,
      /۸/g,
      /۹/g,
    ],
    arabicNumbers = [
      /٠/g,
      /١/g,
      /٢/g,
      /٣/g,
      /٤/g,
      /٥/g,
      /٦/g,
      /٧/g,
      /٨/g,
      /٩/g,
    ];

  let str = this;

  for (let i = 0; i < 10; i++) {
    str = str
      .replace(persianNumbers[i], i.toString())
      .replace(arabicNumbers[i], i.toString());
  }

  return str;
};

String.prototype.numberFormat = function() {
  return this.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};

String.prototype.splitNumberFormat = function() {
  return this.split(",").join("");
};

String.prototype.phoneFormat = function(char = "-") {
  if (this.length !== 11) return this;
  return [this.substr(0, 4), this.substr(4, 3), this.substr(7, 4)].join(char);
};

String.prototype.getNumbers = function() {
  return this.split("")
    .filter((char) => /[0-9, ۰-۹]/.test(char))
    .join("");
};
